/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Switch } from 'react-router-dom';

import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import AnimatedRoute from './AnimatedRoute';
import StartUpRoutes from './StartUpRoutes';

export default function Router(): JSX.Element {
  return (
    <Switch>
      {StartUpRoutes()}
      {PublicRoutes()}
      {PrivateRoutes()}
      <AnimatedRoute>
        {/* The page component goes here */}
        <p>Not Found!!</p>
      </AnimatedRoute>
    </Switch>
  );
}
